{
  "title": "Summon Shadowspawn",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (tears inside a crystal vial worth at least 300 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth a shadowy spirit. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Shadow Spirit stat block. When you cast the spell, choose an emotion: Fury, Despair, or Fear. The creature resembles a misshapen biped marked by the chosen emotion, which determines certain traits in its stat block. The creature disappears when it drop to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after your. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and it uses its move to avoid danger.",
    "At Higher Levels. When you cast the spell using a spell slot of 4th level or higher, use the higher level wherever the spell’s level appears on the stat block.",
    "Shadow Spirit",
    "Medium monstrosity",
    "Armor Class: 11 + the level of the spell (natural armor)",
    "Hit Points: 35 + 15 for each level of the spell above 3rd",
    "Speed: 40 ft.",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "13 (+1)",
    "16 (+3)",
    "15 (+2)",
    "4 (−3)",
    "10 (+0)",
    "16 (+3)",
    "Damage Resistances: necrotic",
    "Condition Immunities: frightened",
    "Senses: darkvision 120 ft., passive Perception 10",
    "Languages: understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Terror Frenzy (Fury Only). The spirit has advantage on attack rolls against frightened creatures.",
    "Weight of Sorrow (Despair Only). Any creature, other than you, that starts its turn within 5 feet of the spirit has its speed reduced by 20 feet until the start of that creature’s next turn.",
    "Actions",
    "Multiattack. The spirit makes a number of attacks equal to half this spell’s level (rounded down).",
    "Chilling Hand. Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d12 + 3 + the spell’s level cold damage.",
    "Dreadful Scream (1/Day). The spirit screams. Each creature within 30 feet of it must succeed on a Wisdom saving throw against your spell save DC or be frightened of the spirit for 1 minute. The frightened creature can repeat the saving throw at the end of each of its turns, ending the effect on itself on a success.",
    "Bonus Action",
    "Shadow Stealth (Fear Only). While in dim light or darkness, the spirit takes the Hide action."
  ],
  "spellLists": ["warlock", "wizard"]
}
